import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ACTIVE_CREDENTIAL_TYPES, CREDENTIAL_TYPES, CREDENTIAL_TYPE_COLUMNS } from '../../../../utils/constants';

export const cache = new InMemoryCache({
  typePolicies: {
    GeneralSettings: {
      keyFields: [],
    },
    Grouping: {
      fields: {
        info: {
          read(_, { variables, readField }) {
            const { value } = variables;
            if (!value) {
              throw new Error('client directive requeries the value argument=CredentialType.value');
            }
            let data;
            let programs;
            let universityName;
            switch (value) {
              case CREDENTIAL_TYPES.DEGREE:
              case CREDENTIAL_TYPES.GRADUATE_CERTIFICATE:
                programs = readField('programs');
                data = programs.map((program) => program.degreeOffering).join(', ');
                break;
              case CREDENTIAL_TYPES.SHORT_COURSE:
                universityName = readField('universityName');
                data = universityName;
                break;
              default:
                data = '';
            }
            return data;
          },
        },
      },
    },
    CredentialType: {
      fields: {
        isActive: {
          read(_, { readField }) {
            return ACTIVE_CREDENTIAL_TYPES.includes(readField('value'));
          },
        },
        columnsName: {
          read(_, { readField }) {
            const value = readField('value');
            return CREDENTIAL_TYPE_COLUMNS[value];
          },
        },
        groupings: {
          merge(existing = [], incoming, { readField }) { // eslint-disable-line no-unused-vars
            const orderedByName = [...incoming].sort((refA, refB) => {
              const nameA = readField('name', refA) || '';
              const nameB = readField('name', refB) || '';
              return nameA.localeCompare(nameB);
            });
            return orderedByName;
          },
        },
      },
    },
  },
});

export const client = new ApolloClient({
  uri: '/api/v1/form',
  cache,
  devtools: {
    enabled: true,
  },
});
